<div class="metin-notu-dialog">
  <!-- Toolbar - Point Selection -->
  <div class="catia-toolbar">
    <div class="toolbar-grup">
      <div class="ayar-satir">
        <button class="catia-btn" [class.active]="nokta" (click)="noktaSec()"
                style="flex: 1; background: linear-gradient(135deg, rgba(0, 255, 255, 0.15), rgba(0, 255, 255, 0.25)); border-color: rgba(0, 255, 255, 0.4); color: #00FFFF;">
          <i class="icon circle outline"></i>
          {{nokta ? 'Nokta Seçildi ✓' : 'Nokta Seç'}}
        </button>
      </div>
    </div>
  </div>

  <!-- Control Panel -->
  <div class="kontrol-paneli">

    <!-- Datum Ayarları -->
    <div class="ayar-sekme">
      <div class="sekme-baslik" (click)="datumAyarlariAcik = !datumAyarlariAcik">
        <i class="icon circle outline"></i>
        <span>Datum Ayarları</span>
        <div class="chevron" [class.right]="!datumAyarlariAcik" [class.down]="datumAyarlariAcik"></div>
      </div>

      @if (datumAyarlariAcik) {
      <div class="sekme-icerik">
        <!-- Datum Harfi -->
        <div class="ayar-satir">
          <label>Datum Harfi:</label>
          <input type="text" [(ngModel)]="datumHarfi" (ngModelChange)="onizlemeGuncelle()"
                 class="catia-input" placeholder="A" maxlength="1"
                 style="width: 100%; padding: 0.25rem 0.3rem; height: 24px; text-transform: uppercase; text-align: center; font-weight: bold; font-size: 14px;" />
        </div>

        <!-- Şekil -->
        <div class="ayar-satir">
          <label>Çerçeve:</label>
          <select [(ngModel)]="sekil" (ngModelChange)="onizlemeGuncelle()" class="catia-select">
            @for (sekil of sekilSecenekleri; track sekil.value) {
            <option [value]="sekil.value">{{sekil.label}}</option>
            }
          </select>
        </div>

        <!-- Çerçeve Boyutu -->
        <div class="ayar-satir">
          <label>Boyut:</label>
          <div class="slider-kontrol">
            <input type="range" [(ngModel)]="cerceveBoyutu" (ngModelChange)="onizlemeGuncelle()"
                   min="0.5" max="2.5" step="0.1" />
            <span class="deger-gosterge">{{cerceveBoyutu.toFixed(1)}}</span>
          </div>
        </div>
      </div>
      }
    </div>

    <!-- Görünüm Ayarları -->
    <div class="ayar-sekme">
      <div class="sekme-baslik" (click)="gorunumAyarlariAcik = !gorunumAyarlariAcik">
        <i class="icon eye"></i>
        <span>Görünüm Ayarları</span>
        <div class="chevron" [class.right]="!gorunumAyarlariAcik" [class.down]="gorunumAyarlariAcik"></div>
      </div>

      @if (gorunumAyarlariAcik) {
      <div class="sekme-icerik">
        <!-- Renk -->
        <div class="ayar-satir">
          <label>Renk:</label>
          <div class="renk-kontrol">
            <div class="renk-palette">
              @for (r of renkler; track r) {
              <div class="renk-kutu" [style.background-color]="r"
                   [class.secili]="renk === r"
                   (click)="renk = r; onizlemeGuncelle()"></div>
              }
            </div>
            <input type="color" [(ngModel)]="renk" (ngModelChange)="onizlemeGuncelle()" class="renk-input" />
          </div>
        </div>

        <!-- Font Boyutu -->
        <div class="ayar-satir">
          <label>Yazı Boyutu:</label>
          <div class="slider-kontrol">
            <input type="range" [(ngModel)]="boyut" (ngModelChange)="onizlemeGuncelle()"
                   min="8" max="24" step="1" />
            <span class="deger-gosterge">{{boyut}}px</span>
          </div>
        </div>

        <!-- Sabit Boyut -->
        <div class="ayar-satir">
          <label>Sabit Boyut:</label>
          <div class="checkbox-kontrol">
            <input type="checkbox" [(ngModel)]="sabitBoyut" (ngModelChange)="sabitBoyutDegistir()" id="sabitBoyutDatum" class="catia-checkbox">
            <label for="sabitBoyutDatum" class="checkbox-label">Aktif</label>
          </div>
        </div>
      </div>
      }
    </div>

  </div>

  <!-- Action Bar -->
  <div class="aksiyon-bar">
    <button class="catia-btn ekle-btn" (click)="ekle()" [disabled]="!nokta || !datumHarfi">
      <i class="icon plus"></i>
      Ekle
    </button>
    <button class="catia-btn kapat-btn" (click)="kapat()">
      <i class="icon times"></i>
      Kapat
    </button>
  </div>
</div>
